import { useAppConfigurationStore } from '@/stores/useAppConfigurationStore'
import { registerGuard } from '@/router/guards'
import { createRouter, createWebHistory, Router, RouterScrollBehavior } from 'vue-router'
import { initialRoutes } from './initialRountes'

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
    // always scroll to top
    return { left: 0, top: 0 };
};

const router = createRouter({
    history: createWebHistory(),
    routes: initialRoutes,
    scrollBehavior,
})
registerGuard(router)

function addRoute(router: Router, route: any) {
   
    if (router.hasRoute(route.name)) {
        router.removeRoute(route.name);
    }
    if (!router.hasRoute(route.name)) {
        router.addRoute(route);
    }
}




export const dynamicRoutes = (router: Router) => {

    const appConfigurationStore = useAppConfigurationStore()

    let route = {
        path: appConfigurationStore.configuration.paths.home,
        name: 'home',
        meta: { requiresAuth: true },
        component: () => import('../pages/HomePage.vue')
    };

    addRoute(router, route);


    route = {
        path: appConfigurationStore.configuration.paths.myEvents,
        name: 'my-events',
        meta: { requiresAuth: true },
        component: () => import('../pages/events/MyEventsPage.vue')
    };

    addRoute(router, route);

    // Integration page route
    route = {
        path: '/integration',
        name: 'integration',
        component: () => import('../pages/IntegrationPage.vue')
    };

    addRoute(router, route);

}

router.beforeEach((to, from, next) => {

    if (router.hasRoute('my-events')) {
   //     replaceRoute(router);
    }

    next();
});
/*
router.onError((error, to) => {
    if (
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Importing a module script failed')
    ) {
        if (!to?.fullPath) {
            window.location.reload();
        } else {
            window.location = to.fullPath;
        }
    }
})

*/

export default router
